
import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const StudioBooking = lazy(() => import('../pages/studio-booking/page'));
const Quote = lazy(() => import('../pages/quote/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const AdminLogin = lazy(() => import('../pages/admin-login/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Loading 컴포넌트
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

// Suspense로 감싸는 헬퍼 함수
const withSuspense = (Component: React.ComponentType) => (
  <Suspense fallback={<LoadingSpinner />}>
    <Component />
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: withSuspense(Home),
  },
  {
    path: '/studio-booking',
    element: withSuspense(StudioBooking),
  },
  {
    path: '/quote',
    element: withSuspense(Quote),
  },
  {
    path: '/admin-login',
    element: withSuspense(AdminLogin),
  },
  {
    path: '/admin',
    element: withSuspense(Admin),
  },
  {
    path: '*',
    element: withSuspense(NotFound),
  },
];

export default routes;
